import React, { ChangeEvent, useCallback, useContext, useState } from 'react';
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    VStack,
    InputGroup,
    InputRightElement,
    useBoolean,
    Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { AuthenticationContext } from '../../contexts/AuthenticationContext';

export interface LoginData {
    email: string;
    password: string;
}
interface Props {
    onLogin: (data: LoginData) => void;
}

function LoginForm(props: Props) {
    const {
        onLogin,
    } = props;

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const [showPassword, setShowPassword] = useBoolean();

    const {
        setLoggedIn,
    } = useContext(AuthenticationContext);

    const handleEmailChange = (
        e: ChangeEvent<HTMLInputElement>,
    ) => setEmail(e.target.value);

    const handlepasswordChange = (
        e: ChangeEvent<HTMLInputElement>,
    ) => setPassword(e.target.value);
    const navigate = useNavigate();

    const handleSubmit = useCallback(
        (event) => {
            event.preventDefault();
            if (!password || !email) {
                return;
            }
            onLogin({
                email,
                password,
            });
            setLoggedIn.on();
            navigate('/manage_dimensions');
            // NOTE: Time out is the response time when url processed
        },
        [password, email, onLogin, setLoggedIn, navigate],
    );

    return (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <VStack spacing={4}>
                {/* TODO: Handle isInvalid later */}
                <FormControl>
                    <FormLabel htmlFor="email">
                        Email *
                    </FormLabel>
                    <Input
                        id="email"
                        value={email}
                        onChange={handleEmailChange}
                        placeholder="Enter email"
                        background="whiteAlpha.900"
                        // isRequired
                        autoComplete="off"
                        // type="email"
                        minHeight={12}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel htmlFor="password">
                        Password *
                    </FormLabel>
                    <InputGroup size="md">
                        <Input
                            id="password"
                            value={password}
                            onChange={handlepasswordChange}
                            placeholder="Enter password"
                            background="whiteAlpha.900"
                            // isRequired
                            autoComplete="off"
                            type={showPassword ? 'text' : 'password'}
                            minHeight={12}
                        />
                        <InputRightElement width="4.5rem">
                            <Button h="1.75rem" size="sm" onClick={setShowPassword.toggle}>
                                {showPassword ? 'Hide' : 'Show'}
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </FormControl>
                <Button
                    type="submit"
                    colorScheme="brand"
                    variant="outline"
                    letterSpacing={1}
                    width="100%"
                    minHeight={12}
                >
                    Login
                </Button>
                <Text mt={2} fontSize="md" fontWeight="semibold" lineHeight="short">
                    ** Login has not been implemented. You can put random values **
                </Text>
            </VStack>
        </form>
    );
}
export default LoginForm;
